import { cleanClass } from '@shared/utils/cleanClass.js';

const PageHeader = ({ children, name = '', style }) => {
  return (
    <div className={cleanClass(`comp-page-header ${name}`)} style={style}>
      {children}
    </div>
  );
};

export default PageHeader;
